import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { CurvaAbcVendaExcelExportModalComponent } from './export';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CurvaAbcVendaExcelExportModalComponent
    ],
    exports: [
        CurvaAbcVendaExcelExportModalComponent
    ]
})
export class CurvaAbcVendaExcelModule { }
